import PlaceHolderLoading from "./PlaceHolderLoading";
export default PlaceHolderLoading;
